import { BAILocale } from '.';
import en_US from 'antd/es/locale/en_US';

const localeValue: BAILocale = {
  lang: 'en',
  antdLocale: en_US,
};

export default localeValue;
